module.exports = __webpack_public_path__ + "img/ben-partner-hero.137b66dc.svg";